// src/views/litellm/components/RecentEventsFeed.jsx
import React from "react";
import { usd, compactNumber, clockTime } from "../format";

// RecentEventsFeed is the newest-first live tail of raw events. The key is shown
// only via its server-masked `display`.
export default function RecentEventsFeed({ events = [] }) {
  return (
    <div className="bg-card rounded-card border border-card-bd p-5">
      <div className="text-xs font-semibold uppercase tracking-wide text-text-3 mb-3">Recent events</div>
      {events.length === 0 ? (
        <div className="text-sm text-text-3 py-4">No recent events.</div>
      ) : (
        <table className="text-sm" style={{ width: "100%" }}>
          <thead>
            <tr className="text-text-3 text-xs uppercase tracking-wide">
              <th className="text-left font-semibold pb-2">Time (UTC)</th>
              <th className="text-left font-semibold pb-2">Model</th>
              <th className="text-left font-semibold pb-2">API key</th>
              <th className="text-left font-semibold pb-2">Call type</th>
              <th className="text-right font-semibold pb-2">Cost</th>
              <th className="text-right font-semibold pb-2">Tokens</th>
            </tr>
          </thead>
          <tbody>
            {events.map((e) => (
              <tr key={e.request_id} className="border-t border-card-bd">
                <td className="py-2 text-left tabular-nums text-text-2">{clockTime(e.ingest_ts)}</td>
                <td className="py-2 text-left text-text">{e.model || "—"}</td>
                <td className="py-2 text-left text-text-2">{e.display}</td>
                <td className="py-2 text-left text-text-2">{e.call_type || "—"}</td>
                <td className="py-2 text-right tabular-nums text-text-2">{usd(e.cost)}</td>
                <td className="py-2 text-right tabular-nums text-text-2">{compactNumber(e.quantity)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
